import i18n from "i18next";
import type { FC } from "react";

import type { FormFieldFactoryProps, FormFieldWrapperProps } from "../../types/types";
import { FormFieldInputStyle, FormFieldLabelStyle, VerticalFormFieldStyle } from "../styles/FormFieldsStyle";

interface VerticalFormFieldWrapperProps {
    field?: FormFieldFactoryProps;
    formComponent: React.JSX.Element;
}

export const VerticalFormFieldWrapper: FC<VerticalFormFieldWrapperProps> = ({ field, formComponent }: FormFieldWrapperProps) => {
    // Check if the field is a UsersTable and if the identity service is Entra or IDM. Remove the wrong table label from the form;
    if (
        // eslint-disable-next-line no-underscore-dangle
        (field?.component === "DataGroupIdmUsersTable" && window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra") ||
        // eslint-disable-next-line no-underscore-dangle
        (field?.component === "DataGroupUsersTable" && window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "idm")
    ) {
        return null;
    }

    return (
        (field?.translationKeys && (
            <VerticalFormFieldStyle>
                <FormFieldLabelStyle>{i18n.t(field.translationKeys.label)}</FormFieldLabelStyle>
                <FormFieldInputStyle>{formComponent}</FormFieldInputStyle>
            </VerticalFormFieldStyle>
        )) ||
        null
    );
};
